<!--
* 类型筛选
* @version 1.0
-->
<template>
  <div
    class="select-category-right"
    :class="[hasMore && !showMore ? 'hidden-more' : 'padding-bottom-8']"
    :ref="filtrateId"
  >
    <span
      class="item"
      v-for="(item, index) in dataList"
      :key="index"
      :class="{
        'filt-active': keyProp.id
          ? checked.id === item[keyProp.id]
          : checked.id === item.id,
        disabled: loading,
        pointer: !loading
      }"
      @click="selectedItem(item)"
    >
      {{ keyProp.name ? item[keyProp.name] : item.name }}
    </span>
    <span
      v-if="hasMore"
      class="show-more item"
      :class="{ shouqi: showMore }"
      @click="showMore = !showMore"
      >{{ showMore ? "收起" : "展开"
      }}<i :class="[showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"></i
    ></span>
  </div>
</template>

<script>
export default {
  components: {},
  data: function() {
    return {
      hasMore: false, //内容是否超出固定高度
      showMore: false, //是否显示更多
      // initHeight: 46,
      isinit: true //是否初次加载
    };
  },
  props: {
    dataList: {
      type: Array,
      default: function() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Object,
      default: function() {
        return {};
      }
    },
    keyProp: {
      type: Object,
      default: function() {
        return { id: "id", name: "name" };
      }
    },
    initHeight: {
      type: Number,
      default: 46
    },
    filtrateId:{
      type: String,
      default: `filtrate_${new Date().getTime()}}`
    }
  },
  watch: {
    dataList: {
      handler: function() {
        this.showMore = false;
        this.isinit = true;
        this.resetListContentHeight();
      },
      immediate: true
    },
    checked: {
      handler: function() {
        this.showActiveItem();
      },
      immediate: true
    }
  },
  mounted() {},
  methods: {
    // 判断右边内容是否超出高度，若超出则显示展开按钮
    resetListContentHeight() {
      this.$nextTick(() => {
        let currentHeight = this.$refs[this.filtrateId].offsetHeight;
        this.hasMore = currentHeight <= this.initHeight ? false : true;
      });
    },
    selectedItem(item) {
      this.$emit("selectChange", item);
    },
    //初次加载时， 如果选中的item处于超出高度的位置,则展开整个分类模块
    showActiveItem() {
      if (this.isinit && this.checked.id && this.checked.name) {
        this.isinit = false;
        this.$nextTick(() => {
          let selectDom = this.$refs[this.filtrateId].querySelector(".filt-active");
          this.showMore =
            selectDom && selectDom.offsetTop > 9 ? true : this.showMore;
        });
      }
    }
  }
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.select-category-right {
  position: relative;
  padding: 0 68px 0 20px;
}
.item {
  display: inline-block;
  padding: 0 15px;
  margin: 8px 0 0;
  color: #343434;
  height: 30px;
  line-height: 30px;
  border-radius: 4px;
}
.filt-active {
  background-color: #b79255;
  color: #fff;
}
.show-more {
  position: absolute;
  top: 0;
  right: 0px;
  font-size: 12px;
  color: #666;
  cursor: pointer;
  padding: 0px 10px;
  i {
    color: #969696;
    margin-left: 3px;
  }
}
.hidden-more {
  height: 40px;
  overflow: hidden;
}
.shouqi,
.shouqi i {
  color: #f60 !important;
}
.pointer {
  cursor: pointer;
}
.disabled {
  cursor: not-allowed;
}
.padding-bottom-8 {
  padding-bottom: 8px;
}
</style>
